// columns/TypeColumn.tsx
import React from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Tooltip, Typography } from "@mui/material";
import { Label, LabelType } from "../../../model/Label";
import Icon from "../../../components/ui/Icon";

const TypeCellRenderer = (params: GridRenderCellParams<Label>) => {
  const labelType = params.row.type;
  let icon: "lightbulb" | "database" | "gear";
  let label: string;
  let color: string;

  if (labelType === LabelType.AIDE_CHAMP) {
    icon = "lightbulb";
    label = "Help Text";
    color = "bg-amber-100 text-amber-800 border-amber-200";
  } else if (labelType === LabelType.I15D) {
    icon = "database";
    label = "Database";
    color = "bg-blue-100 text-blue-800 border-blue-200";
  } else {
    icon = "gear";
    label = "UI Label";
    color = "bg-green-100 text-green-800 border-green-200";
  }

  return (
    <Tooltip title={label} placement="right">
      <div className={`flex items-center gap-1 px-2 py-1 rounded-full ${color} border text-xs font-medium`}>
        <Icon icon={icon} />
        <span className="hidden sm:inline">{label.split(" ")[0]}</span>
      </div>
    </Tooltip>
  );
};

const TypeHeaderRenderer = () => (
  <Typography variant="subtitle2" fontWeight="medium">
    Type
  </Typography>
);

export const typeColumn: GridColDef = {
  field: "type",
  headerName: "Type",
  width: 120,
  headerClassName: "labels-table--header",
  renderHeader: TypeHeaderRenderer,
  renderCell: TypeCellRenderer,
  type: "singleSelect",
  valueOptions: [
    { value: LabelType.AIDE_CHAMP, label: "Help Text" },
    { value: LabelType.I15D, label: "Database" },
    { value: LabelType.PROPERTIES, label: "UI Label" },
  ],
};
